<template>
	<div>
		<FormUserCursos
			:userCursosEdit="userCursosEdit"
			:cursos="cursos"
			:usuario="usuario"
			:typeForm="typeForm"
			@changeTypeForm="changeTypeForm"
			v-if="showFormUserCursos"
		></FormUserCursos>
		<FormProvaNota
			:provaId="tempProvaId"
			:userCursoId="tempUserCursoId"
			:provaNota="tempProvaNota"
			:typeForm="typeForm"
			@changeTypeForm="changeTypeForm"
			v-if="showFormProvaNota"
		></FormProvaNota>
		<FormCursoCertificado
			:curso="tempCurso"
			:typeForm="typeForm"
			@changeTypeForm="changeTypeForm"
			v-if="showFormCursoCertificado"
		></FormCursoCertificado>
		<FormUserCursoAula
			:aula="tempAula"
			:userCursoId="tempUserCursoId"
			:typeForm="typeForm"
			@changeTypeForm="changeTypeForm"
			v-if="showFormUserCursoAula"
		></FormUserCursoAula>
		<OpenChoice :choice="choice" @choiceResult="choiceResult" />
		<v-row>
			<v-col cols="12">
				<v-btn :to="{ name: 'Users' }" color="green" dark class="mr-2">
					<v-icon small left>fal fa-arrow-left</v-icon> Voltar
				</v-btn>
				<v-btn color="green" dark @click="formUserCursos(0, null)" title="Adicionar">
					<v-icon small left>fal fa-plus</v-icon> Curso
				</v-btn>
			</v-col>
		</v-row>

		<v-card>
			<v-card-title>
				<v-icon left>fal fa-backpack</v-icon> {{ usuario.nome }}
			</v-card-title>
			<v-card-subtitle>
				<v-icon small left>fal fa-id-card</v-icon> {{ usuario.cpf }} <br />
				<v-icon small left>fal fa-envelope</v-icon> {{ usuario.email }}
			</v-card-subtitle>
		</v-card>

		<v-expansion-panels v-if="userCursos" focusable class="mt-2">
			<v-expansion-panel v-for="curso in userCursos" :key="curso.id">
				<v-expansion-panel-header>
					<div>
						<v-icon small left class="Curso">far fa-chalkboard</v-icon>
						<v-icon
							x-small
							left
							:color="curso.mostrar==1? 'green darken-1' : 'grey darken-1'"
							title="Mostrar"
							>far fa-eye</v-icon
						>
						<small title="Data do cadastro">{{ $date(curso.datacad).format('DD/MM/YYYY') }}</small> -
						{{ curso.nome }}
					</div>
				</v-expansion-panel-header>
				<v-expansion-panel-content class="pt-2">
					<v-btn
						outlined small
						:color="curso.mostrar==1? 'green darken-1' : 'grey darken-1'"
						title="Editar curso"
						@click="dialogChoice('userCursoMostrar', curso, null)"
						class="mr-2"
					>
						<v-icon small left>far fa-eye</v-icon>
						Mostrar
					</v-btn>

					<v-expansion-panels v-if="curso.materias" focusable class="mt-2" accordion>
						<v-expansion-panel
							v-for="materia in curso.materias"
							:key="materia.id"
						>
							<v-expansion-panel-header>
								<div>
									<v-icon small left title="Matéria">far fa-books</v-icon>
									<v-icon
										x-small
										left
										:color="materia.mostrar==1 ? 'green darken-1' : 'grey darken-1'"
										title="Mostrar matéria"
										>far fa-eye</v-icon
									>
									{{ materia.nome }}
								</div>
							</v-expansion-panel-header>
							<v-expansion-panel-content class="pt-2">

								<div v-if="materia.aulas" class="ml-2">
									<div
										v-for="aula in materia.aulas"
										:key="aula.id"
										class="mb-3 ml-2"
									>
										<v-divider class="mb-3"></v-divider>
										<v-icon	small left title="Aula">far fa-chalkboard-teacher</v-icon>
										<v-icon
											x-small
											left
											:color="aula.mostrar==1 ? 'green darken-1' : 'grey darken-2'"
											title="Mostrar aula"
										>far fa-eye</v-icon>
										<v-icon
											x-small
											left
											:color="aula.completa !== null ? 'green darken-1' : 'grey darken-1'"
											title="Aula completa"
											>far fa-check-circle</v-icon
										>
										{{ aula.nome }}

										<div v-if="aula.data_inicio==null" class="ml-8 pt-2">
											<v-btn
												outlined small
												color="green darken-1"
												title="Adicionar tempo"
												@click="formUserCursoAula(0, curso.user_curso_id, aula)"
												class="mr-2"
											>
												<v-icon small left>far fa-eye</v-icon>
												Adicionar tempo
											</v-btn>
										</div>
										<div v-else class="ml-8 pt-2">
											Acesso de {{ aula.data_inicio_formatada }} à {{ aula.data_final_formatada }} - {{ aula.dias_acesso }} dias de acesso <br>
											<v-btn
												outlined small
												color="green darken-1"
												title="Editar tempo"
												@click="formUserCursoAula(1, curso.user_curso_id, aula)"
												class="mr-2"
											>
												<v-icon small left>far fa-eye</v-icon>
												Editar tempo
											</v-btn>
										</div>

									</div>
								</div>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</div>
</template>
<script>
import { mapState } from 'vuex'

import FormUserCursos from '@/components/admin/FormUserCursos'
import FormProvaNota from '@/components/admin/FormProvaNota'
import FormCursoCertificado from '@/components/admin/FormCursoCertificado'
import FormUserCursoAula from '@/components/admin/FormUserCursoAula'
import OpenChoice from '@/components/OpenChoice'

export default {
	components: {
		FormUserCursos,
		FormProvaNota,
		FormCursoCertificado,
		FormUserCursoAula,
		OpenChoice,
	},
	data() {
		return {
			server: 'user_curso',
			usuario: {},
			cursos: [],
			userId: null,
			showFormUserCursos: false,
			showFormProvaNota: false,
			showFormCursoCertificado: false,
			showFormUserCursoAula: false,
			userCursosEdit: null,
			userCursos: [],
			choice: {
				title: 'Você tem certeza?',
				dialog: false,
			},
			tempMethod: null,
			tempData: null,
			tempGetId: null,
			tempProvaId: null,
			tempUserCursoId: null,
			tempProvaNota: null,
			tempCurso: null,
			tempAula: null,
		}
	},
	beforeRouteUpdate(to, from, next) {
		this.userId = to.params.id
		next()
	},
	computed: {
		...mapState(['user', 'searchUserCursos']),
	},
	created() {
		this.userId = this.$route.params.id
	},
	watch: {
		userId() {
			this.getData()
		},
		searchUserCursos(val) {
			if (val === true) {
				this.getData()
			}
		},
	},
	methods: {
		dialogChoice(method, data, getId) {
			this.tempMethod = method
			this.tempData = data
			this.tempGetId = getId
			this.choice.dialog = true
		},
		choiceResult(value) {
			if (value === true) {
				if(this.tempMethod == 'userCursoMostrar'){
					this.userCursoMostrar()
				}else if(this.tempMethod == 'userCursoCertificado'){
					this.userCursoCertificado()
				}else if(this.tempMethod == 'materiaCompleta'){
					this.materiaCompleta()
				}
			} else {
				this.tempMethod = null
				this.tempData = null
				this.tempGetId = null
				this.$store.dispatch('alert', {
					alertMessage: 'Alteração cancelada',
					alertType: 1,
				})
			}
		},
		userCursoMostrar(){
			let formData = new FormData()
			this.tempData.mostrar = (this.tempData.mostrar==0)?1:0
			formData.append('menu', this.server)
			formData.append('function', 'update_user_curso_mostrar')
			formData.append('user_id', this.user.id)
			formData.append('id', this.tempData.user_curso_id)
			formData.append('mostrar', this.tempData.mostrar)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.tempMethod = null
						vd.tempData = null
						vd.$store.dispatch('alert', {
							alertMessage: response.data.alertMessage,
							alertType: 0,
						})
						vd.getData()
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destination: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERROR!! ' + response)
				})
		},
		materiaCompleta(){
			if(this.tempData.materia_completa_id !== null){
				this.tempData.liberar = (this.tempData.liberar==0)?1:0
				let formData = new FormData()
				formData.append('menu', this.server)
				formData.append('function', 'update_materia_completa')
				formData.append('user_id', this.user.id)
				formData.append('id', this.tempData.materia_completa_id)
				formData.append('liberar', this.tempData.liberar)
				let vd = this
				this.$axiosPost
					.post('functions.php', formData, {
						headers: { Authorization: this.user.token },
					})
					.then(function(response) {
						if (response.data.error === 0) {
							vd.tempMethod = null
							vd.tempData = null
							vd.tempGetId = null
							vd.$store.dispatch('alert', {
								alertMessage: response.data.alertMessage,
								alertType: 0,
							})
							vd.getData()
						} else {
							vd.$store.dispatch('errorServer', {
								data: response.data,
								destination: vd.$route.path,
							})
						}
					})
					.catch(function(response) {
						console.log('ERROR!! ' + response)
					})
			}else{
				let formData = new FormData()
				formData.append('menu', this.server)
				formData.append('function', 'insert_materia_completa')
				formData.append('user_id', this.user.id)
				formData.append('materia_id', this.tempData.id)
				formData.append('user_curso_id', this.tempGetId)
				let vd = this
				this.$axiosPost
					.post('functions.php', formData, {
						headers: { Authorization: this.user.token },
					})
					.then(function(response) {
						if (response.data.error === 0) {
							vd.tempMethod = null
							vd.tempData = null
							vd.tempGetId = null
							vd.$store.dispatch('alert', {
								alertMessage: response.data.alertMessage,
								alertType: 0,
							})
							vd.getData()
						} else {
							vd.$store.dispatch('errorServer', {
								data: response.data,
								destination: vd.$route.path,
							})
						}
					})
					.catch(function(response) {
						console.log('ERROR!! ' + response)
					})
			}
			
		},
		getData() {
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'get_start')
			formData.append('user_id', this.user.id)
			formData.append('id', this.userId)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					vd.$store.dispatch('searchUserCursos', { value: false })
					if (response.data.error === 0) {
						vd.usuario = response.data.user
						vd.cursos = response.data.cursos
						vd.userCursos = response.data.user_cursos
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
		},
		formUserCursos(type, userCursos) {
			this.typeForm = type
			if (type === 0) {
				this.userCursosEdit = {}
			} else {
				this.userCursosEdit = Object.assign({}, userCursos)
			}
			this.showFormUserCursos = true
			setTimeout(() => {
				this.$store.dispatch('dialogUserCursos', { value: true })
			}, 300)
		},
		formProvaNota(type, provaId, userCursoId, provaNota) {
			this.typeForm = type
			this.tempProvaId = provaId
			this.tempUserCursoId = userCursoId
			if (type === 0) {
				this.tempProvaNota = {}
			} else {
				this.tempProvaNota = Object.assign({}, provaNota)
			}
			this.showFormProvaNota = true
			setTimeout(() => {
				this.$store.dispatch('dialogProvaNota', { value: true })
			}, 300)
		},
		formCursoCertificado(curso) {
			this.tempCurso = Object.assign({}, curso)
			this.showFormCursoCertificado = true
			this.typeForm = (curso.certificado_mostrar==null)?0:1
			setTimeout(() => {
				this.$store.dispatch('dialogCursoCertificado', { value: true })
			}, 300)
		},
		formUserCursoAula(type, userCursoId, aula) {
			this.typeForm = type
			this.tempAula = Object.assign({}, aula)
			this.tempUserCursoId = userCursoId
			this.showFormUserCursoAula = true
			setTimeout(() => {
				this.$store.dispatch('dialogUserCursoAula', { value: true })
			}, 300)
		},
		changeTypeForm(value) {
			this.typeForm = value.typeForm
			if (value.hideForm == 'userCursos') {
				this.showFormUserCursos = false
			}
			if (value.hideForm == 'provaNota') {
				this.tempProvaId = null
				this.tempUserCursoId = null
				this.tempProvaNota = null
				this.showFormProvaNota = false
			}
			if (value.hideForm == 'cursoCertificado') {
				this.tempCurso = null
				this.showFormCursoCertificado = false
			}
			if (value.hideForm == 'userCursoAula') {
				this.tempAula = null
				this.tempUserCursoId = null
				this.showFormUserCursoAula = false
			}
		},
		colorCertificado(certificado_mostrar){
			if(certificado_mostrar!=null){
				if(certificado_mostrar == 1){
					return 'brown darken-1'
				}else{
					return 'grey darken-1'
				}
			}else{
				return 'grey darken-1'
			}
		}
	},
}
</script>
<style lang="css">
	.v-expansion-panel-header{
		padding: 16px 18px !important;
	}
</style>